import React from 'react'

import { AttackTypeIcon } from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import {
  AttackDescription,
  AttackRow,
  TargetsColumn,
  DetailsChevron
} from 'components/navigation/Notifications/AttackRows/common/AttackRow'
import { IlfiTargets } from 'components/navigation/Notifications/AttackRows/common/Targets'
import { getNextScheduled } from 'components/navigation/Notifications/utils'
import useMetadata from 'hooks/use-metadata'

import type { AttackSchedule } from 'types/api/schedules/active'

export const ScheduledAttackRow: React.FC<{ schedule: AttackSchedule }> = ({
  schedule
}) => {
  const { trigger } = schedule
  const { getAttackName } = useMetadata()

  return (
    <AttackRow
      data-scheduled-attack-row
      css={{
        gridTemplateColumns: 'minmax(172px, 1fr) minmax(0, 1fr) 24px'
      }}
      to="/schedules/attacks"
    >
      <AttackDescription
        description={getNextScheduled(trigger)}
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={schedule.command.type} />
          </GlyphIcon>
        }
        name={getAttackName(schedule.command.type)}
      />
      <TargetsColumn>
        <IlfiTargets
          targets={
            schedule.target.type === 'Random'
              ? ['Random']
              : schedule.target.exact ||
                (schedule.target.containers || schedule.target.hosts).ids
          }
        />
      </TargetsColumn>
      <DetailsChevron />
    </AttackRow>
  )
}
